import { SocialProfile } from "@/models/Social/social-profile";
import { SocialLikes, SocialLikesType} from "@/models/Social/social-likes";

export enum SocialMediaSourceType {
    VIDEO = "video",
    IMAGE = "image"
}

export enum SocialMediaShape {
    VERTICAL = "vertical",
    SQUARE   = "square"
}

export interface SocialMediaSource{
    source: string,
    poster?: string,
    type: SocialMediaSourceType,
}

export interface SocialMedia{
    shape: SocialMediaShape,
    sources: Array<SocialMediaSource>
}

export interface SocialPost{
    id: string,
    text: string,
    transaction?: string,
    commentsNum?: number,
    date?: string,
    products?: Array<string>,
    media?: SocialMedia,
    productsMub?: object,
    // for club mode swipe (mobile), mention modals navigation (desktop)
    previousPostId?: string,
    nextPostId?: string,
}

export class SocialMention{
    protected _profile?: SocialProfile;
    protected _post?: SocialPost;
    protected _like: SocialLikes = new SocialLikes(0,false);

    public constructor(profile: SocialProfile|undefined, post?: SocialPost|undefined) {
        this._profile = profile;
        if(post && !post.products){
            post.products = [];
        }
        this._post   = post;
    }

    public get profile(): SocialProfile{ return this._profile ?? new SocialProfile('',''); }
    public get post(): SocialPost { return this._post ?? {id: '', text: ''}; }

    public get products(): Array<string> { return this.post.products ?? []; }
    public set products(value: Array<string>) { this.post.products = value; }

    public get like(): SocialLikes { return this._like; }
    public set like(value: SocialLikes) { this._like = value; }

    public hasTransaction(): boolean {
        return this.post.transaction ? true : false;
    }

    public static create(profile: SocialProfile, values: any):SocialMention{
        let media: SocialMedia = {
            shape: (values?.media?.shape ?? '-').toLowerCase() == 'vertical' ? SocialMediaShape.VERTICAL : SocialMediaShape.SQUARE,
            sources: (values?.media?.sources ?? []).map( (s: any): SocialMediaSource  => {
                return {
                    source: s.source ?? undefined,
                    poster: s.poster ?? undefined,
                    type: (s.type ?? '-').toLowerCase() == 'video' ? SocialMediaSourceType.VIDEO : SocialMediaSourceType.IMAGE
                };
            })
        }
        
        let post: SocialPost = {
            id: values.id ?? '',
            text: values.text ?? '',
            transaction: values.transaction ?? '',
            commentsNum: values.commentsNum ?? 0,
            products: values.products ?? [],
            date: values.date ?? undefined,
            media: media.sources.length > 0 ? media : undefined,
            productsMub: values.productsMub ?? undefined,
            previousPostId: values.previousPostId ?? undefined,
            nextPostId: values.nextPostId ?? undefined,
        };

        let m = new SocialMention(profile,post);
        m.like = new SocialLikes(values.likes ?? 0, values.liked ?? false);
        m.like.id = values.id ?? undefined;
        m.like.showNum = values.showLikesNum ?? true;
        m.like.type = SocialLikesType.MENTION;
        return m;
    }
}